export default __webpack_public_path__ + "static/media/trending-up.140d2a88.svg";